import Checkbox from 'components/common/checkbox/checkbox';

import { useSummary } from 'contexts/summary.context';

import {
  StyledCheckBoxWrapper,
  StyledLabel,
  StyledLabelText,
  StyledCheckBoxItem,
  StyledCheckBoxList
} from './checkbox-list.style';

const CheckboxList = () => {
  const { data, summary, handleSelectOne } = useSummary();

  return (
    <StyledCheckBoxWrapper>
      <StyledCheckBoxList>
        {data.map(({ value, label }) => (
          <StyledCheckBoxItem key={value}>
            <StyledLabel>
              <Checkbox
                type="secondary"
                disabled={
                  summary.length === 1 && summary.some((name) => name === value)
                }
                checked={summary.some((name) => name === value)}
                onChange={() => handleSelectOne(value)}
              >
                <StyledLabelText>{label}</StyledLabelText>
              </Checkbox>
            </StyledLabel>
          </StyledCheckBoxItem>
        ))}
      </StyledCheckBoxList>
    </StyledCheckBoxWrapper>
  );
};

export default CheckboxList;
